import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ButtonStyle = styled.div`
  .button {
    font-size: 1.6rem;
    font-weight: 600;
    padding: 1.4rem 3.5rem;
    border-radius: var(--radius-lg);
    display: inline-block;
    position: relative;
    overflow: hidden;
    transition: var(--transition-normal);
    border: 2px solid transparent;
    text-transform: uppercase;
    letter-spacing: 1px;
    
    ${(props) =>
      props.outline
        ? `
      background: transparent;
      color: var(--text-primary);
      border: 2px solid var(--accent-primary);
      
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background: var(--gradient-primary);
        transition: var(--transition-normal);
        z-index: -1;
      }
      
      &:hover {
        color: var(--text-primary);
        border-color: transparent;
        transform: translateY(-2px);
        box-shadow: var(--shadow-glow);
        
        &::before {
          width: 100%;
        }
      }
    `
        : `
      background: var(--gradient-primary);
      color: var(--text-primary);
      box-shadow: var(--shadow-md);
      
      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 100%);
        opacity: 0;
        transition: var(--transition-normal);
      }
      
      &:hover {
        transform: translateY(-3px);
        box-shadow: var(--shadow-glow);
        
        &::after {
          opacity: 1;
        }
      }
    `}
    
    &:active {
      transform: translateY(-1px);
    }
  }
  
  @media only screen and (max-width: 768px) {
    .button {
      font-size: 1.4rem;
      padding: 1.2rem 2.5rem;
    }
  }
`;

export default function Button({
  btnLink = 'Test',
  btnText = 'Test',
  outline = false,
}) {
  return (
    <ButtonStyle outline={outline} className="button-wrapper">
      <Link className="button" to={btnLink}>
        {btnText}
      </Link>
    </ButtonStyle>
  );
}
